import Calendar5 from '@crehana/icons/Calendar5';
import Calendar5Filled from '@crehana/icons/Calendar5Filled';
import Diploma from '@crehana/icons/Diploma';
import FileText from '@crehana/icons/FileText';
import FileTextOutline from '@crehana/icons/FileTextOutline';
import BookmarkFilled from '@crehana/icons/fill/Bookmark';
import Bookmark from '@crehana/icons/outline/Bookmark';
import Pencil from '@crehana/icons/Pencil';
import PencilOutline from '@crehana/icons/PencilOutline';
import PlaySquare from '@crehana/icons/PlaySquare';
import PlaySquareOutline from '@crehana/icons/PlaySquareOutline';

import type { RouteType } from '../components/DashboardTemplate/types';
import ClassNotes from './ClassNotes';
import Diplomas from './Diplomas';
import Enrollments from './Enrollments';
import Projects from './Projects';
import { ENROLLMENTS_ROUTE_PATH, ENROLLMENTS_ROUTES } from './route-paths';
import SavedCourses from './SavedCourses';
import StudyPlan from './StudyPlan';
import { SAVED_COURSES_KEY, SAVED_COURSES_SELECTOR } from './selectors';

export {
  BASE_URL,
  ENROLLMENTS_ACADEMIES_ROUTE,
  ENROLLMENTS_BOOTCAMPS_ROUTE,
  ENROLLMENTS_BUNDLES_ROUTE,
  ENROLLMENTS_CAREERS_ROUTE,
  ENROLLMENTS_COURSES_ROUTE,
  ENROLLMENTS_DEGREES_ROUTE,
  ENROLLMENTS_ROUTES,
  ENROLLMENTS_TRACKS_ROUTE,
} from './route-paths';

export const ENROLLMENTS_ROUTE = {
  key: 'ENROLLMENTS',
  path: ENROLLMENTS_ROUTE_PATH,
  subpaths: ENROLLMENTS_ROUTES.map(route => route.path),
  exact: false,
  component: Enrollments,
  icon: PlaySquareOutline,
  activeIcon: PlaySquare,
  tourSelector: 'enrollments-tab',
};

export const CLASSNOTES_ROUTE = {
  key: 'CLASSNOTES',
  path: '/mis-apuntes/',
  exact: true,
  component: ClassNotes,
  icon: FileTextOutline,
  activeIcon: FileText,
  tourSelector: 'classnotes-tab',
};

export const PROJECTS_ROUTE = {
  key: 'PROJECTS',
  path: '/mis-proyectos/',
  exact: true,
  component: Projects,
  icon: PencilOutline,
  activeIcon: Pencil,
  tourSelector: 'projects-tab',
};

export const DIPLOMAS_ROUTE = {
  key: 'DIPLOMAS',
  path: '/mis-diplomas/',
  exact: true,
  component: Diplomas,
  icon: Diploma,
  activeIcon: Diploma,
  tourSelector: 'diplomas-tab',
};

export const STUDY_PLAN_ROUTE = {
  key: 'STUDY_PLAN',
  path: '/mi-plan-de-estudios/',
  exact: true,
  component: StudyPlan,
  icon: Calendar5,
  activeIcon: Calendar5Filled,
  tourSelector: 'study-plan-tab',
};

export { SAVED_COURSES_KEY, SAVED_COURSES_SELECTOR } from './selectors';
export const SAVED_COURSES_ROUTE = {
  key: SAVED_COURSES_KEY,
  path: '/mis-cursos-guardados/',
  exact: false,
  component: SavedCourses,
  icon: Bookmark,
  activeIcon: BookmarkFilled,
  tourSelector: SAVED_COURSES_SELECTOR,
};

const ROUTES: Omit<RouteType, 'label'>[] = [
  ENROLLMENTS_ROUTE,
  SAVED_COURSES_ROUTE,
  CLASSNOTES_ROUTE,
  PROJECTS_ROUTE,
  DIPLOMAS_ROUTE,
  STUDY_PLAN_ROUTE,
];

export default ROUTES;
